import type { ReactNode } from 'react';

type Tone = 'ok' | 'low' | 'warn' | 'danger' | 'info' | 'neutral';

const TONE: Record<Tone, string> = {
  ok: 'bg-emerald-100 text-emerald-800 ring-emerald-200',
  low: 'bg-amber-100 text-amber-800 ring-amber-200',
  warn: 'bg-yellow-100 text-yellow-800 ring-yellow-200',
  danger: 'bg-red-100 text-red-800 ring-red-200',
  info: 'bg-sky-100 text-sky-800 ring-sky-200',
  neutral: 'bg-slate-100 text-slate-700 ring-slate-200',
};

export function Badge({
  tone = 'neutral',
  children,
}: {
  tone?: Tone;
  children: ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset ${TONE[tone]}`}
    >
      {children}
    </span>
  );
}
